export default "__VITE_ASSET__xHjTRXXx__"